import { Product } from '../../../interfaces/domain/menu';
import { formatPrice } from '../../../utils/formatersPrecio';
import styles from './PricePlate.module.scss';

interface PricePlateProps {
  plate: Product;
  priceClassName?: string;
}

export const PricePlate = ({
  plate,
  priceClassName = "",
}: PricePlateProps) => {
  if (!plate) return null;
  const isSuper =
    plate.tags?.includes("superdestacado") ?? false;

  return (
    <div
      className={`
        ${
          isSuper
            ? styles.containerSuperPriceQuantity
            : styles.containerPriceQuantity
        }
      `}
    >
      <span className={`${styles.price} ${priceClassName}`}>
        {formatPrice(plate.price, { emptyLabel: "Consultar" })}
      </span>
    </div>
  );
};